import React from "react";
import Icon from '../AppIcon';



const Input = React.forwardRef(({
  type = 'text',
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  className = '',
  containerClassName = '',
  fullWidth = false,
  ...props
}, ref) => {
  const baseClasses = 'touch-target w-full px-4 py-2.5 mobile-body bg-background border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-smooth disabled:opacity-50 disabled:cursor-not-allowed';
  
  const errorClasses = error ? 'border-destructive focus:ring-destructive' : '';
  const widthClass = fullWidth ? 'w-full' : '';
  const iconPaddingLeft = leftIcon ? 'pl-11' : '';
  const iconPaddingRight = rightIcon ? 'pr-11' : '';

  const inputClasses = `
    ${baseClasses}
    ${errorClasses}
    ${iconPaddingLeft}
    ${iconPaddingRight}
    ${className}
  `;

  return (
    <div className={`${widthClass} ${containerClassName}`}>
      {label && (
        <label className="block mobile-body font-medium text-foreground mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <Icon name={leftIcon} size={18} color="var(--color-muted-foreground)" />
          </div>
        )}
        <input
          ref={ref}
          type={type}
          className={inputClasses}
          {...props}
        />
        {rightIcon && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <Icon name={rightIcon} size={18} color="var(--color-muted-foreground)" />
          </div>
        )}
      </div>
      {error && (
        <p className="mobile-caption text-destructive mt-1.5 flex items-center gap-1">
          <Icon name="AlertCircle" size={14} />
          {error}
        </p>
      )}
      {!error && helperText && (
        <p className="mobile-caption text-muted-foreground mt-1.5">
          {helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;